export interface IErrorIconProps {}

export const ErrorIcon = ({}: IErrorIconProps) => {
    return (
        <svg
            width="36"
            height="34"
            viewBox="0 0 36 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_1380_11234)">
                <path
                    d="M16.2094 12.2207H18.8966V18.9389H16.2094V12.2207ZM16.208 20.2825H18.8953V22.9698H16.208V20.2825Z"
                    fill="white"
                />
                <path
                    d="M19.9261 4.42694C19.4585 3.54686 18.5475 3 17.5506 3C16.5536 3 15.6426 3.54686 15.175 4.42828L5.31544 23.0551C5.09666 23.4641 4.98828 23.9231 5.001 24.3868C5.01373 24.8505 5.14711 25.3029 5.388 25.6993C5.62542 26.0976 5.96259 26.427 6.36623 26.6551C6.76987 26.8832 7.22602 27.002 7.68964 27H27.4115C28.3628 27 29.224 26.5136 29.7145 25.6993C29.955 25.3028 30.0881 24.8504 30.1009 24.3868C30.1136 23.9232 30.0054 23.4642 29.787 23.0551L19.9261 4.42694ZM7.68964 24.3127L17.5506 5.68592L27.4182 24.3127H7.68964Z"
                    fill="white"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_1380_11234"
                    x="0"
                    y="0"
                    width="35.1016"
                    height="34"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="2" />
                    <feGaussianBlur stdDeviation="2.5" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.51 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1380_11234"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1380_11234"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};
